module.exports = __webpack_public_path__ + "media/metronic/_theme/media/illustrations/working-23cda36485995a23fea93007411a893b.svg";